<app-organizer-shared-layout-dashboard
  class="organizer-activity-page-manage"
  [hasHeader]="hasHeader"
>
  <app-organizer-shared-header
    class="col-span-12 mb-3 lg:col-span-6"
    [title]="'organizer.manage_activity.title' | translate"
    [backLink]="backLink"
    [backLinkAriaLabel]="'a11y.organizer.manage_activity.back' | translate"
  >
    <a
      *ngIf="isActivityPreviewOpenInNewTab"
      class="flex items-center ml-auto text-vtmn-play-content-brand font-bold"
      [routerLink]="['/attendee.show-activity/', activity.sku] | localize"
      [queryParams]="httpParams"
      target="_blank"
      [rel]="'noopener noreferrer'"
    >
      {{ 'editing_activity.preview_button' | translate }}
      <vtmn-play-icon
        class="text-xl ml-1"
        [name]="iconType.ChevronRight"
      ></vtmn-play-icon>
    </a>

    <a
      *ngIf="!isActivityPreviewOpenInNewTab"
      class="flex items-center ml-auto text-vtmn-play-content-brand font-bold"
      [routerLink]="['/attendee.show-activity/', activity.sku] | localize"
      [queryParams]="httpParams"
    >
      {{ 'editing_activity.preview_button' | translate }}
      <vtmn-play-icon
        class="text-xl ml-1"
        [name]="iconType.ChevronRight"
      ></vtmn-play-icon>
    </a>
  </app-organizer-shared-header>

  <div class="col-span-12 lg:col-start-2 lg:col-span-5 lg:mb-3">
    <app-activity-card
      *ngIf="!isDraftActivity"
      [picture]="picture"
      [title]="activity.name"
      [address]="activity.fullAddress"
      [isLive]="activity.isLive"
      [price]="activity.startingPrice?.amount"
      [isStartingPrice]="true"
      [currency]="activity.minPriceOffer?.currency"
      [variant]="activityCardVariant.SHADOWLESS"
      [visibility]="activity.visibility"
    ></app-activity-card>

    <app-activity-draft-card
      *ngIf="isDraftActivity"
      [draftActivity]="activity"
    ></app-activity-draft-card>

    <app-divider
      *ngIf="isTabletDevice"
      [variant]="dividerVariant.Large"
      class="block -mx-3 mb-6 xs:-mx-6 sm:-mx-9"
    ></app-divider>

    <app-organizer-shared-action-list
      class="block lg:mt-6"
      [title]="'organizer.manage_activity.options' | translate"
    >
      <button
        *appListItem
        app-cta
        ctaClass="py-2 lg:pl-3"
        [variant]="ctaVariant.Link"
        [width]="ctaWidth.Full"
        [leftIconType]="iconType.ShareApple"
        (click)="openShareModal()"
      >
        {{ 'organizer.manage_activity.actions.share' | translate }}

        <vtmn-play-icon
          class="ml-auto text-2xl"
          [name]="icon?.ChevronRight"
        ></vtmn-play-icon>
      </button>

      <a
        *appListItem
        app-cta
        ctaClass="py-2 lg:pl-3"
        [variant]="ctaVariant.Link"
        [width]="ctaWidth.Full"
        [leftIconType]="iconType.Edit"
        [routerLink]="getActivityEditLink(activity.sku)"
      >
        {{
          'organizer.manage_activity.actions.edit_activity.label' | translate
        }}

        <vtmn-play-icon
          class="ml-auto text-2xl lg:pl-3"
          [name]="icon?.ChevronRight"
        ></vtmn-play-icon>
      </a>

      <button
        *appListItem
        app-cta
        ctaClass="py-2 lg:pl-3"
        [variant]="ctaVariant.Link"
        [width]="ctaWidth.Full"
        [leftIconType]="iconType.CalendarCheck"
        (click)="goToActivityPlanning()"
        type="button"
      >
        {{ 'organizer.manage_activity.actions.new_dates' | translate }}

        <vtmn-play-icon
          class="ml-auto text-2xl"
          [name]="icon?.ChevronRight"
        ></vtmn-play-icon>
      </button>

      <ng-container *appIsEnabled="activityManagementDuplicationToggle">
        <button
          *appListItem
          app-cta
          ctaClass="py-2 lg:pl-3"
          [variant]="ctaVariant.Link"
          [width]="ctaWidth.Full"
          [leftIconType]="iconType.FunctionTitles"
          (click)="duplicateActivity()"
        >
          {{ 'organizer.manage_activity.actions.duplicate' | translate }}

          <vtmn-play-icon
            class="ml-auto text-2xl"
            [name]="icon?.ChevronRight"
          ></vtmn-play-icon>
        </button>
      </ng-container>

      <ng-container *appIsEnabled="activityManagementCancelToggle">
        <button
          *appListItem
          app-cta
          ctaClass="py-2 lg:pl-3"
          [variant]="ctaVariant.LinkDisruptive"
          [width]="ctaWidth.Full"
          [leftIconType]="iconType.DeleteBin"
          (click)="showConfirmActivityCancellationModal()"
          type="button"
        >
          {{ 'organizer.manage_activity.actions.delete_date' | translate }}

          <vtmn-play-icon
            class="ml-auto text-2xl text-grey-dark-3"
            [name]="icon?.ChevronRight"
          ></vtmn-play-icon>
        </button>
      </ng-container>
    </app-organizer-shared-action-list>

    <app-alert-modal
      [confirmLabel]="
        'organizer.manage_activity.delete_modal.confirm.button' | translate
      "
      [closeLabel]="
        'organizer.manage_activity.delete_modal.abort.button' | translate
      "
      (modalClose)="closeConfirmActivityCancellationModal()"
      (modalConfirm)="deleteActivity()"
    >
      <div modal-header>
        {{ 'organizer.manage_activity.delete_modal.header' | translate }}
      </div>
      <div modal-content>
        {{ 'organizer.manage_activity.delete_modal.text' | translate }}
      </div>
    </app-alert-modal>

    <app-modal
      *ngIf="hasShareModal"
      #shareModal
      (modalClose)="shareModal.hide()"
      [modalVariant]="modalVariant.Secondary"
    >
      <div modal-header>
        <p>{{ 'organizer.manage_activity.share_modal.title' | translate }}</p>
      </div>

      <div modal-content>
        <app-sharer-buttons [url]="activityUrl"></app-sharer-buttons>
      </div>
    </app-modal>

    <app-success-overlay
      *ngIf="showDuplicationSuccess"
      [successTitle]="'activity_duplicating.success.title' | translate"
      [successDescription]="
        'activity_duplicating.success.description' | translate
      "
      [loadingTitle]="'activity_duplicating.loading.title' | translate"
      [loadingDescription]="
        'activity_duplicating.loading.description' | translate
      "
      [status]="successStatus"
    >
      <button
        app-vtmn-play-button
        type="button"
        [type]="ctaButtonType.Button"
        (click)="editDuplicatedActivity()"
      >
        {{ 'activity_duplicating.button.edit_activity' | translate }}
      </button>
    </app-success-overlay>

    <app-success-overlay
      *ngIf="showDeletionSuccess"
      [successTitle]="
        'organizer.manage_activity.deletion.success.title' | translate
      "
      [successDescription]="
        'organizer.manage_activity.deletion.success.description' | translate
      "
      [loadingTitle]="
        'organizer.manage_activity.deletion.loading.title' | translate
      "
      [loadingDescription]="
        'organizer.manage_activity.deletion.loading.description' | translate
      "
      [status]="successStatus"
    >
      <button
        app-vtmn-play-button
        type="button"
        [type]="ctaButtonType.Button"
        (click)="redirectAfterDeletion()"
      >
        {{ 'organizer.manage_activity.deletion.button' | translate }}
      </button>
    </app-success-overlay>
  </div>

  <div
    class="col-span-12 lg:col-span-4 lg:col-start-8 lg:row-start-1 lg:row-end-3"
    *ngIf="displayTimeslots"
  >
    <app-divider
      *ngIf="isTabletDevice"
      [variant]="dividerVariant.Large"
      class="block -mx-3 mt-4 mb-6 xs:-mx-6 sm:-mx-9 lg:m-0"
    ></app-divider>

    <app-organizer-shared-activity-timeslot-list
      [activity]="activity"
      [timeslots]="timeslots"
      [hasSeeMoreUrl]="true"
    >
    </app-organizer-shared-activity-timeslot-list>
  </div>

  <app-modal
    #haveIncompleteFieldsModal
    (modalClose)="haveIncompleteFieldsModal.hide()"
  >
    <ng-container modal-header>
      {{
        'organizer.manage_activity.coming_timeslots.incomplete_activity.modal.header'
          | translate
      }}
    </ng-container>

    <p modal-content>
      {{
        'organizer.manage_activity.coming_timeslots.incomplete_activity.modal.content'
          | translate
      }}
    </p>

    <div modal-footer class="flex justify-center items-center">
      <button
        app-vtmn-play-button
        type="button"
        [type]="ctaButtonType.Button"
        [variant]="vtmnPlayButtonVariant.SECONDARY"
        [shape]="vtmnPlayButtonShape.SQUARED"
        (click)="haveIncompleteFieldsModal.hide()"
      >
        {{
          'organizer.manage_activity.actions.edit_activity.cancel' | translate
        }}
      </button>
      <a
        app-vtmn-play-button
        class="ml-2"
        [variant]="vtmnPlayButtonVariant.PRIMARY"
        [shape]="vtmnPlayButtonShape.SQUARED"
        [routerLink]="'organizer.activity-edition.edition' | localize"
      >
        {{
          'organizer.manage_activity.actions.edit_activity.label' | translate
        }}
      </a>
    </div>
  </app-modal>
</app-organizer-shared-layout-dashboard>
